<template>
  <div class="list-card" @click="toggleView('show')">  
    <!-- @click="openModal" -->

    <div class="list-name">
      {{ item.list.listName }}
      <div :class="['btn-state', permissionClass]">
        <span v-if="!this.item.isOwner" class="material-symbols-outlined fs-15 mr-5 icon">share</span>
        {{ permissionText }}
      </div>
    </div>
    <div class="platform-icon-container">
      <div class="material-icon-wrapper icon" @click.stop="handleNotification">
        <template v-if="isNotificationLoading">
          <span class="spinner"></span>
        </template>
        <template v-else>
          <span class="material-symbols-outlined">
            {{ item.isNotification ? 'notifications_active' : 'notification_add' }}
          </span>
        </template>
      </div>
      <div class="material-icon-wrapper icon" @click.stop="toggleMenu">
        <span class="material-symbols-outlined">more_vert</span>
      </div>
      <OptionsMenu 
        v-if="isMenuOpen"
        @closeMenu="closeMenu"
      >
        <ButtonComponent
          label="Edit"
          icon="edit_square"
          :itemId="item.list.id"
          :action="handleShow"
          :disable="isDisabled('show')" 
          :visible="true" 
        />
        <ButtonComponent
          label="Show Items"
          icon="apps"
          :itemId="item.list.id"
          :action="handleShowItems"
          :disable="isDisabled('showItems')" 
          :visible="true" 
        />
        <ButtonComponent
          label="Share"
          icon="Share"
          :itemId="item.list.id"
          :action="handleShare"
          :disable="isDisabled('share')" 
          :visible="true" 
        />
        <ButtonComponent
          label="Delete"
          icon="delete"
          :itemId="item.list.id"
          :action="handleAreYouSureModal"
          :disable="isDisabled('delete')" 
          :visible="true" 
        />
      </OptionsMenu>
    </div>
    <div class="bottom-row b-top-1">
      <div class="app-count">
        {{ item.list.appCount || 0 }}
      </div>
    </div>
    <div class="bottom-row ">
        <!-- <div :class="['btn-state', permissionClass]">
          <span v-if="!this.item.isOwner" class="material-symbols-outlined fs-15 mr-5 icon">share</span>
          {{ permissionText }}
        </div> -->
    </div>
    <div class="platform-icon">
      <template v-if="getStoreImage(item?.list?.platformTypeId).length">
        <img
          v-for="(src, index) in getStoreImage(item?.list?.platformTypeId)"
          :key="index"
          :src="src"
          alt="Platform Icon"
          class="platform-image"
        />
      </template>
    </div>
  </div>
  
  <AreYouSureModal
    v-if="showModal"
    :isVisible="showModal"
    :title="modalTitle"
    :message="modalMessage"
    :itemId="selectedListId"
    :confirmButtonLabel="$t('Custom.delete')"
    :cancelButtonLabel="$t('Custom.cancel')"
    @result="handleModalResult"
  />
</template>

<script>
import { storeImage } from '@/ultis/user/functions/storePlatform';
import ButtonComponent from '@/components/custom/buttons/ButtonComponent.vue';
import OptionsMenu from '@/components/custom/dropdown/OptionsMenuComponent.vue';
import SharingPermissionEnum from '@/enums/SharingPermissionEnum';
import AreYouSureModal from '@/components/custom/modals/AreYouSureModal.vue';
import NotificationComponent from '@/components/custom/notifications/NotificationComponent.vue';

export default {
  name: 'ListCard',
  components: {
    ButtonComponent,
    OptionsMenu, 
    AreYouSureModal,
    NotificationComponent,
  },
  data (){
    return {
      showModal: false,
      modalTitle: '',
      modalMessage: '',
      selectedListId: null,
      isNotificationLoading: false,
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    menuId: Number,
  },
  computed: {
    isMenuOpen() {
      return this.menuId === this.item.list.id;
    },
    permissionClass() {
      switch (this.item.sharingPermissionId) {
        case SharingPermissionEnum.ALL:
          return 'bg-accepted';
        case SharingPermissionEnum.READ:
          return 'bg-hold';
        case SharingPermissionEnum.EDIT:
          return 'bg-edit';
        case SharingPermissionEnum.DELETE:
          return 'bg-rejected';
        default:
          return 'bg-rejected';
      }
    },
    permissionText() {
      return SharingPermissionEnum.fromId(this.item.sharingPermissionId) || 'Unknown';
    },
  },
  methods: {
    getStoreImage(platformTypeId) {
      return storeImage(platformTypeId);
    },
    async handleShow() {
      this.closeMenu();
      this.$emit('open-modal', this.item.list.id);
    },
    async handleShowItems() {
      this.closeMenu();
      this.$emit('show-Items', this.item.list.id, this.item.sharingPermissionId);
    },
    async handleShare(itemId) {
      this.closeMenu();
      this.$emit('share-List', itemId);
    },
    async handleDelete(itemId) {
      this.closeMenu();
      this.$emit('delete-list', itemId);
    },
    async handleNotification() {
      if (this.isNotificationLoading) return
      this.$emit('update-notification', this.item.list.id, this.item.userId, !this.item.isNotification);
    },
    handleAreYouSureModal() {
      this.closeMenu();
      this.selectedListId = this.item.list.id;
      this.modalTitle = this.$t('List.deleteList');
      this.modalMessage = this.$t('List.areYouSureDeleteList') + " <b>" + this.item.list.listName + "</b>";
      this.showModal = true;
    },
    handleModalResult(result) {
      this.showModal = false;
      if (result) {
        this.handleDelete(this.selectedListId);
      }
			this.selectedListId = null;
    },
    toggleMenu() {
      this.$emit('setMenuId', this.item.list.id);
    },
    closeMenu() {
      this.$emit('setMenuId', null);
    },
    isDisabled(button) {
      const permission = this.item.sharingPermissionId;
      switch (button) {
        case 'show':
          return ![SharingPermissionEnum.ALL, SharingPermissionEnum.EDIT].includes(permission);
        case 'showItems':
          return ![SharingPermissionEnum.ALL, SharingPermissionEnum.READ, SharingPermissionEnum.EDIT].includes(permission);
        case 'share':
          return ![SharingPermissionEnum.ALL, SharingPermissionEnum.EDIT].includes(permission);
        case 'delete':
          return !(permission === SharingPermissionEnum.ALL && this.item.isOwner);
        default:
          return true;
      }
    },
    toggleView(isShow) {
      // if (!this.isDisabled(isShow)) this.$emit('show-Items', this.item.list.id, this.item.sharingPermissionId);
      this.$emit('show-Items', this.item.list.id, this.item.sharingPermissionId);
    }
  }
};
</script>

<style scoped>
.platform-icon-container {
  display: flex;
  align-items: center;
  position: absolute;
  top: 10px;
  right: 10px;
}

.material-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 25%;
  padding: 2px;
}

.material-icon-wrapper.icon:hover {
  background-color: rgba(0, 0, 0, 0.1); /* Hover arka plan rengi */
}

.icon span{
  font-size: 20px;
  user-select: none;
}


/* General card styles */
.list-card {
  position: relative;
  display: flex;
  flex-direction: column;
  background: white;
  padding: 25px;
  border: 1px solid #eee;
  border-radius: 8px;
  box-shadow: 0 0 5px #9e9e9e;
  cursor: pointer;
  transition: background-color 0.3s;
  flex: 1 1 calc(22%);
}

.list-card:hover {
  background-color: #f4f5fa;
}

.list-name {
  font-size: 16px;
  color: #333;
  margin-bottom: auto;
  display: flex;
  align-items: end;
  gap: 10px; 
}

.permission-badge {
  display: flex;
  align-items: center;
  font-size: 14px; /* Badge boyutu */
  color: #666; /* Yazı rengi */
  background-color: #f4f4f4; /* Badge arka plan rengi */
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid #ddd; /* Badge çerçeve */
}

.permission-badge .icon {
  font-size: 16px;
  margin-right: 5px; /* İkon ile yazı arasındaki boşluk */
}

/* Options Button (Top Right) */
.options-button {
  position: absolute;
  top: 10px;
  right: 10px;
}

.options-button .material-symbols-outlined {
  font-size: 24px;
  color: #333;
}

/* Bottom Row for App Count and Platform Icons */
.bottom-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  padding-top: 5px;
}

/* App Count (Left) */
.app-count {
  font-size: 30px;
    color: teal;
    text-align: left;
}

/* Platform Icons (Right) */
.platform-icon {
  display: flex;
  gap: 8px;
  justify-content: end;
}

.platform-image {
  width: 24px;
  height: auto;
  user-select: none;
}

.btn-state {
  font-size: 10px !important;
  padding: 4px !important;
  margin: 5px 0px !important;
  min-width: 30px;
}

.btn-state span {
  font-size: 10px !important;
}

/* Responsive design for cards */
@media (max-width: 1200px) {
  .list-card {
    flex: 1 1 calc(50% - 20px);
  }
}

@media (max-width: 768px) {
  .list-card {
    flex: 1 1 100%;
  }
}
</style>
